// src/components/assets/BalancePieChart.js
import React, { useState } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Drawer, Typography, Divider, Button, useTheme } from '@mui/material';

const BalancePieChart = ({ spotBalance, futuresBalance, aiBalance }) => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // حساب الرصيد الإجمالي
  const totalBalance = spotBalance + futuresBalance + aiBalance;

  // حساب النسب المئوية
  const spotPercentage = totalBalance > 0 ? ((spotBalance / totalBalance) * 100).toFixed(1) : 0;
  const futuresPercentage = totalBalance > 0 ? ((futuresBalance / totalBalance) * 100).toFixed(1) : 0;
  const aiPercentage = totalBalance > 0 ? ((aiBalance / totalBalance) * 100).toFixed(1) : 0;

  // بيانات المخطط الدائري مع ألوان محسّنة
  const data = [
    { id: 0, value: spotBalance, label: 'Spot', color: '#4CAF50' }, // أخضر
    { id: 1, value: futuresBalance, label: 'Futures', color: '#FF9800' }, // برتقالي
    { id: 2, value: aiBalance, label: 'AI', color: '#2196F3' }, // أزرق
  ];

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <Box
        sx={{
          ml: 2,
          cursor: 'pointer',
          transition: 'all 0.3s',
          '&:hover': {
            transform: 'scale(1.1)',
            filter: 'drop-shadow(0 0 8px rgba(0, 0, 0, 0.2))',
          },
        }}
        onClick={toggleDrawer}
      >
        <PieChart
          series={[
            {
              data,
              innerRadius: 18,
              outerRadius: 30,
              paddingAngle: 3,
              cornerRadius: 5,
              highlightScope: { faded: 'global', highlighted: 'item' },
              faded: { innerRadius: 15, additionalRadius: -5 },
            },
          ]}
          width={90}
          height={90}
          margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
          slotProps={{
            legend: { hidden: true }, // إخفاء الأسطورة
          }}
        />
      </Box>

      {/* Drawer لعرض التفاصيل */}
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={toggleDrawer}
        PaperProps={{
          sx: {
            bgcolor: theme.palette.background.paper,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            p: 3,
          },
        }}
      >
        <Typography variant="h6" sx={{ color: theme.palette.text.primary, mb: 2 }}>
          Balance Distribution
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: 12, height: 12, bgcolor: '#4CAF50', borderRadius: '50%', mr: 1 }} />
            <Typography sx={{ color: theme.palette.text.secondary }}>
              Spot Account:
            </Typography>
          </Box>
          <Typography sx={{ color: '#4CAF50', fontWeight: 'medium' }}>
            {spotPercentage}% (${spotBalance.toFixed(2)} USDT)
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: 12, height: 12, bgcolor: '#FF9800', borderRadius: '50%', mr: 1 }} />
            <Typography sx={{ color: theme.palette.text.secondary }}>
              Futures Account:
            </Typography>
          </Box>
          <Typography sx={{ color: '#FF9800', fontWeight: 'medium' }}>
            {futuresPercentage}% (${futuresBalance.toFixed(2)} USDT)
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: 12, height: 12, bgcolor: '#2196F3', borderRadius: '50%', mr: 1 }} />
            <Typography sx={{ color: theme.palette.text.secondary }}>
              AI Account:
            </Typography>
          </Box>
          <Typography sx={{ color: '#2196F3', fontWeight: 'medium' }}>
            {aiPercentage}% (${aiBalance.toFixed(2)} USDT)
          </Typography>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Button
          variant="contained"
          sx={{
            bgcolor: theme.palette.brand.main,
            color: theme.palette.text.primary,
            borderRadius: 2,
            transition: 'all 0.3s',
            '&:hover': {
              bgcolor: theme.palette.brand.main,
              transform: 'translateY(-2px)',
              boxShadow: theme.shadows[4],
            },
          }}
          onClick={toggleDrawer}
        >
          Close
        </Button>
      </Drawer>
    </>
  );
};

export default BalancePieChart;